const canIUseWebWorkers = (): boolean =>
  typeof window !== "undefined" && !!window.Worker;

export default canIUseWebWorkers;
